























import { defineComponent } from '@vue/composition-api';
import copy from 'copy-to-clipboard';
import { ButtonType, ParagraphSize } from '@getaccept/lib-ui';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { SelectionHelper } from '@getaccept/dsr-shared';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
      validator: (value: string) => UrlHelper.isValidUrl(value),
    },
  },
  setup(props) {
    const handleCopyUniversalLink = () => {
      SelectionHelper.clearSelection();
      copy(props.url);
    };

    return {
      t,
      ButtonType,
      ParagraphSize,
      handleCopyUniversalLink,
    };
  },
});
